function mobileBridge() {
  return window.paypalMobile || window.venice
}

function callBridgeFunction(funcName, ...args) {
  const bridge = mobileBridge()
  if (bridge) {
    if (typeof bridge[funcName] === 'function') {
      bridge[funcName].apply(bridge, args)
    }
  }
}

export function campaignCreated() {
  callBridgeFunction('created')
}

export function reAuth() {
  callBridgeFunction('reAuth')
}
